import {ImageField, ImageInput, SelectInput, TextInput, useTranslate} from "react-admin";
import {EditPopup} from "../../../components/Admin/Pages/EditPopup/EditPopup";
import {capService} from "../../../services/capService";
import {useParams} from "react-router";
import {CapCategory, CapType} from "../../../dto/cap-dto";

export const CapEdit = () => {
  const t = useTranslate();

  const {collectionId} = useParams();

  const types = Object.keys(CapType).map((type) => ({
    id: type,
    name: t(`resources.caps.options.type.${type}`),
  }));

  const categories = Object.keys(CapCategory).map((type) => ({
    id: type,
    name: t(`resources.caps.options.category.${type}`),
  }));

  return (
    <EditPopup
      updateQuery={(params: { id: any; data: any }) =>
        capService.update({id: params.id, data: {...params.data, collection: collectionId}})
      }
      getRecordQuery={capService.getById}
      maxWidth="sm"
    >
      <SelectInput source="type" fullWidth choices={types}/>
      <SelectInput source="category" fullWidth choices={categories}/>
      <ImageInput source="texture.albedoTransparency" fullWidth
                  accept={{'image/*': ['.png', '.jpg']}}>
        <ImageField source="src" title="title"/>
      </ImageInput>
      <ImageInput source="texture.albedoTransparency2" fullWidth
                  accept={{'image/*': ['.png', '.jpg']}}>
        <ImageField source="src" title="title"/>
      </ImageInput>
    </EditPopup>
  );
};